export const TOGGLE_DRAWER_VISIBLE = 'TOGGLE_DRAWER_VISIBLE';

export const toggleDrawerVisible = () => ({
  type: TOGGLE_DRAWER_VISIBLE,
});
